import Phaser from 'phaser';

export default class Chest extends Phaser.Physics.Arcade.Image {
  opened = false;

  /** 宝箱显示尺寸（瓦片是 32px，宝箱放大到略小于一格更醒目） */
  static readonly SIZE = 28;

  constructor(scene: Phaser.Scene, x: number, y: number, key: string) {
    // 使用专门的宝箱素材
    super(scene, x, y, 'chest');
    scene.add.existing(this);
    scene.physics.add.existing(this, true);
    // 原素材 16×16、瓦片 32px，直接放会有半个格那么小 → 放大到 28px
    this.setDisplaySize(Chest.SIZE, Chest.SIZE);
    // 重新按显示尺寸设置静态碰撞体（静态体不会自动跟随 setDisplaySize）
    (this.body as Phaser.Physics.Arcade.StaticBody).setSize(Chest.SIZE, Chest.SIZE);
    this.setOrigin(0.5, 0.5);
    this.setImmovable(true);
    // 开合呼吸动画（原地轻微起伏，提示可交互）
    scene.tweens.add({
      targets: this,
      scaleX: this.scaleX * 0.94,
      scaleY: this.scaleY * 0.94,
      duration: 900,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }

  open() {
    if (this.opened) return;
    this.opened = true;
    // 切换为打开状态的宝箱贴图
    if (this.scene.textures.exists('chest_open')) {
      this.setTexture('chest_open');
    }
    this.setTint(0xf1c40f);
    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      duration: 500,
      onComplete: () => this.destroy(),
    });
  }
}
